import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      // User interface strings
      "start": "Start",
      "prev": "Previous",
      "next": "Next",
      "see result": "See Assessment Result",
      "confirm to clear all data": "Are you sure you want to clear all data?",
      "clear all data": "Clear all data",
      "clear all data and restart": "Restart",
      "yes, i have": "Yes",
      "no, i have not": "No",
      "list comma": ", ",
      "list and": " and ",

      // Assessment questions: Agreement
      "welcome and introduction": "Welcome to participate in the life management self-assessment analysis, then we will have several simple questions to understand your needs, make assessments and suggestions. In addition, relevant data will also be stored for future analysis of community needs.",
      "i agree": "I agree",

      // Assessment questions: Subject
      "who is this assessment for": "Is this assessment for yourself or for someone else?",
      "myself" : "Myself",
      "others" : "Someone else",

      // Assessment question: Age
      "please enter your age": "What is your current age?",
      "please enter the age of the assessment subject": "What is the current age of the assessment subject?",

      // Assessment question: Health Status
      "please enter your health status": "Have you been diagnosed with a terminal illness, incurable disease, or chronic condition?",
      "please enter the health status of the assessment subject": "Have your assessment subject been diagnosed with a terminal illness, incurable disease, or chronic condition?",

      // Assessment question: Considerations
      "have you considered the following aspects": "Have you considered the following aspects for your future? (Multiple choices)",
      "have the assessment subject considered the following aspects": "Has the assessment subject considered the following aspects for their future? (Multiple choices)",

      // Assessment question: Worries
      "please fill in your worries": "Please fill in your concerns",
      "please fill in the assessment subject's worries": "Please fill in the assessment subject's concerns",
      "what are your worries about the future": "Do you any concert about managing your life in the future?",
      "what are your assessment subject's worries about the future": "Does the assessment subject have any concern about managing your life in the future?",

      // Assessment question: Discuss with Others
      "have you discussed with family or others": "Have you discussed future care plans and life management with relatives or others?",
      "have the assessment subject discussed with family or others": "Has the assessment subject discussed future care plans and life management with relatives or others?",

      // Results
      "results": "Results",
      "although you are still young": "While you are still young, ",
      "although the assessment subject is still young": "While the assessment subject is still young, ",
      "you are approaching your elderly stage": "You are approaching the prime of your life, ",
      "the assessment subject is approaching your elderly stage": "The assessment subject is approaching the prime of your life, ",
      "you have arrived at your elderly stage": "You have entered old age, ",
      "the assessment subject has arrived at elderly stage": "The assessment subject has entered old age, ",
      "diagnosed with a terminal illness": "diagnosed with terminal, incurable disease or chronic illness. ",
      "not diagnosed with a terminal illness": "have not been diagnosed with terminal, incurable disease or chronic illness. ",
      "it's good for you to plan ahead your end of life journey": "Planning ahead for your own life management and future care is a good thing to do.",
      "you need to manage your end of life journey": "There is a need to plan for life management and future care.",
      "you have considered aspects including": "You have already considered {{ aspects }}. You can refer to the services and information in the following link to take action of concern. At the same time, you can browse other aspects of the website to understand more about the impact of related aspects on life management.",
      "the assessment subject has considered aspects including": "The assessment subject has already considered {{ aspects }}. The assessment subject can refer to the services and information in the following link to take action of concern. At the same time, you can browse other aspects of the website to understand more about the impact of related aspects on life management.",
      "despite these, you have not considered any aspects": "Despite these, you have not considered any aspects. You can refer to the services and information in the following link to take action of concern. At the same time, you can browse other aspects of the website to understand more about the impact of related aspects on life management.",
      "despite these, the assessment subject has not considered any aspects": "Despite these, the assessment subject has not considered any aspects. The assessment subject can refer to the services and information in the following link to take action of concern. At the same time, you can browse other aspects of the website to understand more about the impact of related aspects on life management.",
      "besides, you have worries like": "Besides, you have concerns about {{ worries }}.",
      "besides, the assessment subject has worries like": "Besides, the assessment subject has concerns about {{ worries }}.",
      "besides, you have no worries": "Besides, you have no other concerns.",
      "besides, the assessment subject has no worries": "Besides, the assessment subject has no other concerns.",
      "lucky that you have discussed with family or others": "Fortunately, you have communicated with family and others, but remember to update everyone's thoughts when needed, or establish a default care plan to reduce the chances of disputes or regrets in the future.",
      "lucky that the assessment subject has discussed with family or others": "Fortunately, the assessment subject has communicated with family and others, but remember to update everyone's thoughts when needed, or establish a default care plan to reduce the chances of disputes or regrets in the future.",
      "unfortunately, you have not discussed with family or others": "Unfortunately, you have not discussed future care plans and life management with anyone. To reduce the chances of disputes or regrets in the future, you can have relevant conversations with family and others to enhance everyone's understanding of future plans.",
      "unfortunately, the assessment subject hs not discussed with family or others": "Unfortunately, the assessment subject has not discussed future care plans and life management with anyone. To reduce the chances of disputes or regrets in the future, the assessment subject can have relevant conversations with family and others to enhance everyone's understanding of future plans.",
    },
  },
  zh_hant: {
    translation: {
      // User interface strings
      "start": "開始",
      "prev": "上一步",
      "next": "下一步",
      "see result": "查看評估結果",
      "confirm to clear all data": "確定要清除所有數據嗎？",
      "clear all data": "清除資料",
      "clear all data and restart": "重新開始",
      "yes, i have": "有",
      "no, i have not": "沒有",
      "list comma": "、",
      "list and": "及",

      // Assessment questions: Agreement
      "welcome and introduction": "歡迎參與生命管理自我評估分析，接著我們會有數條簡單問題去了解你的對未來的照顧及生命管理 (例如，晚期的健康或照顧需要、個人財務上的安排、預設醫療指示等）的需要，作出評估及建議。另外，相關數據亦會儲存作日後分析社群需要之用。",
      "i agree": "我同意",

      // Assessment questions: Subject
      "who is this assessment for": "是次評估，你的評估對象會是自己或其他人？",
      "myself" : "自己",
      "others" : "其他人",

      // Assessment question: Age
      "please enter your age": "請問你現時歲數為？",
      "please enter the age of the assessment subject": "請問他的現時歲數為？",

      // Assessment question: Health Status
      "please enter your health status": "請問你有沒有被確診末期、不治之症或長期病患？",
      "please enter the health status of the assessment subject": "請問他有沒有被確診末期、不治之症或長期病患？",

      // Assessment question: Considerations
      "have you considered the following aspects": "你有沒有為自己的未來考慮過以下的方面？（多項選擇）",
      "have the assessment subject considered the following aspects": "他有沒有為自己的未來考慮過以下的方面？（多項選擇）",

      // Assessment question: Worries
      "please fill in your worries": "請填寫上你的顧慮",
      "please fill in the assessment subject's worries": "請填寫上他的顧慮",
      "what are your worries about the future": "你對未來的照顧及生命管理，還有什麼顧慮？",
      "what are your assessment subject's worries about the future": "他對未來的照顧及生命管理，還有什麼顧慮？",

      // Assessment question: Discuss with Others
      "have you discussed with family or others": "請問你有沒有與親人或其他可信賴的人士討論過未來的照顧及生命管理？",
      "have the assessment subject discussed with family or others": "請問他有沒有與親人或其他可信賴的人士討論過未來的照顧及生命管理？",

      // Results
      "results": "結果",
      "although you are still young": "你現時雖然相對年輕，",
      "although the assessment subject is still young": "他現時雖然相對年輕，",
      "you are approaching your elderly stage": "你慢慢步入老年，",
      "the assessment subject is approaching your elderly stage": "他慢慢步入老年，",
      "you have arrived at your elderly stage": "你已經步入老年，",
      "the assessment subject has arrived at elderly stage": "他已經步入老年，",
      "diagnosed with a terminal illness": "確診了末期、不治之症或長期病患，",
      "not diagnosed with a terminal illness": "沒有確診任何末期、不治之症或長期病患，",
      "it's good for you to plan ahead your end of life journey": "提早為自己的生命管理及未來照顧作打算，是十分有準備的事情。",
      "you need to manage your end of life journey": "有需要為生命管理及未來照顧作打算。",
      "you have considered aspects including": "你已經在{{ aspects }}作考慮，可以參考以下連結的服務及資訊，以便採取適合的行動。同時，可以瀏覽網站的其他方面，了解更多相關層面對生命管理的影響。",
      "the assessment subject has considered aspects including": "他已經在{{ aspects }}作考慮，可以參考以下連結的服務及資訊，以便採取適合的行動。同時，可以瀏覽網站的其他方面，了解更多相關層面對生命管理的影響。",
      "despite these, you have not considered any aspects": "但你暫時未有在任何層面上的考慮，你可以瀏覽網站的相關資料，從個人、健康、晚期護理及照顧、法律、醫療、財務、以及預設照顧計劃方面，為未來作打算。",
      "despite these, the assessment subject has not considered any aspects": "但他暫時未有在任何層面上的考慮，他可以瀏覽網站的相關資料，從個人、健康、晚期護理及照顧、法律、醫療、財務、以及預設照顧計劃方面，為未來作打算。",
      "besides, you have worries like": "除此之外，你還有{{ worries }}相關的顧慮。",
      "besides, the assessment subject has worries like": "除此之外，他還有{{ worries }}相關的顧慮。",
      "besides, you have no worries": "除此之外，你未有其他的的顧慮。",
      "besides, the assessment subject has no worries": "除此之外，他未有其他的的顧慮。",
      "lucky that you have discussed with family or others": "幸好你已和身邊的親人等作溝通，但記緊有需要時更新大家的想法，或定立預設照顧計劃，減少日後有機會發生的爭執或遺憾。",
      "lucky that the assessment subject has discussed with family or others": "幸好他已和身邊的親人等作溝通，但記緊有需要時更新大家的想法，或定立預設照顧計劃，減少日後有機會發生的爭執或遺憾。",
      "unfortunately, you have not discussed with family or others": "可是你暫未與任何人討論過未來的照顧計劃以及生命管理。為減少日後有機會發生的爭執或遺憾，你可以與身邊的親人或其他人開展相關對話，加強大家對未來計劃的互相了解。",
      "unfortunately, the assessment subject hs not discussed with family or others": "可是他暫未與任何人討論過未來的照顧計劃以及生命管理。為減少日後有機會發生的爭執或遺憾，他可以與身邊的親人或其他人開展相關對話，加強大家對未來計劃的互相了解。",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    fallbackLng: 'zh_hant',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
